<template>
    <div v-on:click="click" class="bg-grey-lighter rounded flex mb-1">
        <div class="p-2 papsi-bg-fader">
            <div class="w-icon h-icon">
                <img v-bind:src="getIcon()" class="block" />
            </div>
        </div>
        <div class="flex-grow text-sm uppercase pl-2 truncate flex justify-content items-center font-bold">
            <span><slot></slot></span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'v-menu',
    props: {
        href: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            required: true,
        },
    },
    methods: {
        click() {
            if(this.href != null) {
                this.$router.push(this.href);
            }
            
            this.$emit('clicked');
        },
        getIcon() {
            return require('./../../assets/' + this.icon);
        },
    }
}
</script>

<style scoped>
.papsi-bg-fader {
    background-color: rgba(255, 255, 255, 0.3);
    display: flex;
    align-items: center; 
    justify-content: center; 
}
</style>
